import { Button } from "@/components/ui/button";

interface OpportunityModalActionsProps {
  onAccept: () => Promise<void>;
  onDecline: () => Promise<void>;
  isLoading?: boolean;
}

export const OpportunityModalActions = ({ 
  onAccept, 
  onDecline,
  isLoading 
}: OpportunityModalActionsProps) => {
  return (
    <div className="flex justify-end gap-3 pt-4 border-t">
      <Button 
        variant="outline" 
        onClick={onDecline}
        disabled={isLoading}
      >
        Decline Invitation
      </Button>
      <Button 
        onClick={onAccept}
        className="bg-green-500 hover:bg-green-600"
        disabled={isLoading}
      >
        Accept
      </Button>
    </div>
  );
};